import { currentBreakpoint } from '../lib/responsive';

export default class StepHandler {

  constructor(el) {

    this.el = el;
    this.steps = [].slice.call(document.querySelectorAll('.tc-mobile-step'));
    this.targetSelector = this.el.getAttribute('href');
    this.targetStep = document.querySelector(this.targetSelector);

    this.registerEvents();

    if (currentBreakpoint === 'xs' || currentBreakpoint === 's') {

      this.setUpSteps();
    }
  }

  registerEvents() {

    this.el.addEventListener('click', this.goToStep.bind(this), false);
    window.addEventListener('hashchange', this.onHachChange.bind(this), false);
    window.addEventListener('changeBreakpoint', this.onResize.bind(this), false);
  }

  setUpSteps() {

    document.body.scrollTop = 0;

    if (window.location.hash.length && window.location.hash === this.targetSelector) {

      this.goToStep();
    } else {

      this.steps[0].classList.remove('hidden-step');

      for (let i = 1; i < this.steps.length; i++) {

        this.steps[i].classList.add('hidden-step');
      }
    }
  }

  resetSteps() {

    for (let i = 0; i < this.steps.length; i++) {

      this.steps[i].classList.remove('hidden-step');
    }
  }

  goToStep() {

    for (let i = 0; i < this.steps.length; i++) {
      //
      // // don't handle steps after the tagret
      // if ( this.steps[i] === this.targetStep ) {
      //
      //   break;
      // }
      this.steps[i].classList.add('hidden-step');
    }

    this.targetStep.classList.remove('hidden-step');
  }

  onHachChange() {

    this.setUpSteps();
  }

  onResize() {

    if (currentBreakpoint === 'xs' || currentBreakpoint === 's') {

      this.setUpSteps();
    } else {

      this.resetSteps();
    }
  }
};
